export default "__VITE_ASSET__74a0b11c__"